import { FETCH_QUEUE_LIST, CREATE_QUEUE, UPDATE_QUEUE } from "./types";

// export const fetchQueues = () => {
//   console.log("Code is coming inside the actions.tsx")
//   return {
//     type: FETCH_QUEUE_LIST,
//   };
// };

export const fetchQueues = (payload?: { location_ids?: string[] }) => {
  return {
    type: FETCH_QUEUE_LIST,
    payload,
  };
};

export const createQueue = (payload: any) => {
  return {
    type: CREATE_QUEUE,
    payload,
  };
};

export const updateQueue = (payload: any) => {
  return {
    type: UPDATE_QUEUE,
    payload,
  };
};
